var $6e7ac060c0da7b7d$exports = {};
$6e7ac060c0da7b7d$exports = {
    "more": `\u{AE30}\u{D0C0} \u{D56D}\u{BAA9}`
};


export {$6e7ac060c0da7b7d$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
